import { useParams } from 'react-router-dom';
import BuyThankYouContainer from './BuyThankYouContainer';
import { ReportPaymentConnectorApollo } from '@front-activerse/common-components';

const BuyThankYouPage = () => {
  const { token } = useParams();

  return (
    <ReportPaymentConnectorApollo>
      {({ reportPayment }) => {
        return <BuyThankYouContainer reportPayment={reportPayment} token={token} />;
      }}
    </ReportPaymentConnectorApollo>
  );
};

export default BuyThankYouPage;
